import React from "react";
import { Box } from "@mui/material";
import CustomTextField from "./CustomTextField";

interface CustomUploadProps {
  label?: string;
  highlightLabelStar?: boolean;
  accept?: string;
  multiple?: boolean;
  onChange: (files: FileList | null) => void;
  disabled?: boolean;
}

const CustomUpload: React.FC<CustomUploadProps> = ({
  label,
  highlightLabelStar = false,
  accept = "*",
  multiple = false,
  onChange,
  disabled = false,
}) => {
  const inputId = `custom-upload-input-${Math.random()
    .toString(36)
    .substr(2, 9)}`;

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.files);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 2,
      }}
    >
      <CustomTextField
        label={label}
        type="file"
        inputProps={{
          accept,
          multiple,
        }}
        onChange={handleFileChange}
        highlightLabelStar={highlightLabelStar}
        fullWidth
        disabled={disabled}
      />
    </Box>
  );
};

export default CustomUpload;